import { render, staticRenderFns } from "./OneShop.vue?vue&type=template&id=281a018a&scoped=true"
import script from "./OneShop.vue?vue&type=script&lang=js"
export * from "./OneShop.vue?vue&type=script&lang=js"
import style0 from "./OneShop.vue?vue&type=style&index=0&id=281a018a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281a018a",
  null
  
)

export default component.exports